// ------------------------
// フチの?をクリックしてモーダル表示
// ------------------------
$(function(){
  const hatenaOpen = $('.js-line-item-property__modal--switch'),
      hatenaClose = $('.js-line-item-property__modal--close'),
      hatenaContainer = $('.js-line-item-property__modal--container');

  hatenaOpen.on('click',function(){	
      hatenaContainer.addClass('active');
      body.addClass('scroll_fixed');
      
  });
  hatenaClose.on('click',function(){	
      hatenaContainer.removeClass('active');
      body.removeClass('scroll_fixed');
  });
  
  $(document).on('click',function(e) {
      if($(e.target).hasClass('active')) {
          hatenaContainer.removeClass('active');
        if(body.hasClass('scroll_fixed')){
          body.removeClass('scroll_fixed');
        }
      }
  });
  
});
